import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=3ea6333a&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=3ea6333a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea6333a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea6333a')) {
      api.createRecord('3ea6333a', component.options)
    } else {
      api.reload('3ea6333a', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=3ea6333a&scoped=true&", function () {
      api.rerender('3ea6333a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notificationList/NotificationItem.vue"
export default component.exports